import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import striptags from 'striptags';
import Social from '../social/social';
import FCLink from '../fc_link/fc_link';
import PostSidebar from '../post/sidebar/post_sidebar';

function processAssetServerImage(imgSrc) {
  if (typeof imgSrc !== 'string') {
    return '';
  }

  return imgSrc.replace(
    'multisite_files/fastcompany',
    'multisite_files/fastcompany/imagecache/w/707/h/398/crop'
  );
}

function renderSocialMedia(product) {
  const socialMedia = get(product, 'social_media') || [];
  const name = get(product, 'name');

  if (!socialMedia.length) return null;

  return (
    <div className="person-page-bio__social-media">
      <span className="person-page-bio__social-media-title">
        {name} On The Web
      </span>
      {socialMedia.map(item =>
        <div key={item.name} className="person-page-bio__social-media-item">
          {item.name === 'Website'
            ? <a href={item.value}>{item.name}</a>
            : <a href={`https://${item.name}.com/${item.value}`}>
                {item.name}
              </a>}
        </div>
      )}
    </div>
  );
}

function creatorListGenerator(people, companies) {
  if (!people && !companies) return null;
  let i;
  const list = [];
  if (people) {
    for (i = 0; i < people.length; i += 1) {
      list.push(`${people[i].first_name} ${people[i].last_name}`);
    }
  }

  if (companies) {
    for (i = 0; i < companies.length; i += 1) {
      list.push(companies[i].name);
    }
  }

  return list.join(', ');
}

export default function ProductPage(props) {
  const { product, combinedAdModel } = props;
  const name = get(product, 'name');
  const description = get(product, 'description');
  const url = `https://www.fastcodesign.com/product/${get(product, 'url')}`;
  const poster = processAssetServerImage(get(product, 'images[0].url'));
  const posterCaption = striptags(get(product, 'images[0].caption')).length
    ? striptags(get(product, 'images[0].caption'))
    : null;
  const posterCredit = striptags(get(product, 'images[0].credit')).length
    ? striptags(get(product, 'images[0].credit'))
    : null;
  // const socialMedia = get(product, 'social_media');
  const firms = get(product, 'firms');
  const creatorPeople = get(product, 'creator_people');
  const creatorCompany = get(product, 'creator_company');
  const creatorList = creatorListGenerator(creatorPeople, creatorCompany);

  const encodedUrl = encodeURIComponent(url);
  const shareCopy = encodeURIComponent(
    `Read more about ${name} on @FastCoDesign`
  );

  return (
    <section className="post post--product">
      <div className="post__main">
        <header className="post__header">
          <ul className="eyebrow">
            <li className="eyebrow__item"><a href="/stuff">Product</a></li>
            <li className="eyebrow__item">Profile</li>
          </ul>
          <FCLink currentSite="fastcodesign" to={url} title={name}>
            <h1 className="post__title">{name}</h1>
          </FCLink>
          <h2 className="post__deck post__deck--creators">
            {firms.length
              ? firms.map(firm =>
                  <a
                    key={firm.url}
                    href={`//www.fastcompany.com/company/${firm.url}`}
                  >
                    {firm.name}
                  </a>
                )
              : ''}
          </h2>
          <div>
            {poster
              ? <figure className="poster post-featured__poster">
                  <img src={poster} alt={name} title={name} />
                </figure>
              : ''}
            {posterCaption || posterCredit
              ? <div className="post__featured-caption">
                  {`${posterCaption || ''}${posterCredit || ''}`}
                </div>
              : ''}
          </div>
        </header>
        <div className="post__container">
          <Social
            enableSticky={false}
            text={shareCopy}
            uri={encodedUrl}
            modifier="product-page"
          />
          <div className="post__content">
            <article
              className="post__article"
              dangerouslySetInnerHTML={{ __html: description }}
            />
            {creatorList
              ? <div className="product-creators">
                  <span className="product-creators__title">Creators: </span>
                  <span className="product-creators__list">{creatorList}</span>
                </div>
              : ''}
            {renderSocialMedia(product)}
          </div>
        </div>
      </div>
      <PostSidebar
        post={product}
        postExtras={false}
        combinedAdModel={combinedAdModel}
        site={'fastcodesign'}
        relatedHeight={0}
        fullPageAdvertorial={false}
        totalAdCount={1}
      />
    </section>
  );
}

ProductPage.propTypes = {
  product: PropTypes.shape({}).isRequired,
  combinedAdModel: PropTypes.shape({}).isRequired
};



// WEBPACK FOOTER //
// ./src/views/components/product_post/product_post.js